import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import type { IncomingHttpHeaders } from 'http';

import { adWriteApi } from '../../../../api/adWriteApi';
import { formatAuthorizationHeader } from '../../../../helpers/auth';
import { useAuthOptions } from '../../../../contexts/UserContext';

const metaInfoItemSchema = z.object({
  name: z.string().optional(),
  displayValue: z.string().optional(),
  value: z.string().optional(),
});

const metaInfoBlockSchema = z.object({
  items: z.array(metaInfoItemSchema).optional(),
});

export const vehicleLookupResponseSchema = z
  .object({
    metaInfoBlock: metaInfoBlockSchema,
    hiddenFields: metaInfoBlockSchema,
  })
  .passthrough();

export type VehicleLookupResponse = z.infer<typeof vehicleLookupResponseSchema>;

const fetchVehicleLookup = async ({
  registration,
  headers,
}: {
  registration: string;
  headers: IncomingHttpHeaders;
}): Promise<VehicleLookupResponse> => {
  const { data } = await adWriteApi.refinedVehicleRegistrationNumberLookup(
    registration,
    'cars',
    headers,
  );
  return vehicleLookupResponseSchema.parse(data);
};

export const useGetVehicleLookup = () => {
  const { accessToken } = useAuthOptions();

  return useMutation({
    mutationFn: (registration: string) =>
      fetchVehicleLookup({
        registration,
        headers: formatAuthorizationHeader(accessToken),
      }),
    meta: { noToast: true },
  });
};
